import { TranscriptionService, VideoService } from '@klangio/ai2notes-ts-client';
import { type Transcription } from '../entities';
import { backendService } from '../services';

function saveByteArray(fileName: string, byteArray: ArrayBuffer, fileType = 'application/pdf') {
  const blob = new Blob([byteArray], { type: fileType });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

function saveXML(fileName: string, xml: string) {
  // regex to replace metadata field
  const regex = /(<miscellaneous>.+?<\/miscellaneous>)/gm;
  const link = document.createElement('a');
  link.href = `data:xml/plain;charset=utf-8,${encodeURIComponent(xml.replace(regex, ''))}`;
  link.download = fileName;
  link.click();
}

function saveText(fileName: string, text: string) {
  const link = document.createElement('a');
  link.href = `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`;
  link.download = fileName;
  link.click();
}

export const handleDownloadMidi = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.setAxiosResponseTypeToBlob();
  const response = TranscriptionService.transcriptionMidi(transcription.id).then((buffer) => {
    saveByteArray(`${transcription.title}.mid`, buffer as any, 'audio/midi');
  });
  backendService.clearAxiosConfig();
  return response;
};

export const handleDownloadMusicXML = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.clearAxiosConfig();
  const response = TranscriptionService.transcriptionMusicXml(transcription.id).then((xml) => {
    saveXML(`${transcription.title}.musicxml`, xml as any);
  });
  return response;
};
export const handleDownloadPdf = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.setAxiosResponseTypeToBlob();
  const response = TranscriptionService.transcriptionPdf(transcription.id).then((buffer) => {
    saveByteArray(`${transcription.title}.pdf`, buffer as any);
  });
  backendService.clearAxiosConfig();
  return response;
};

export const handleDownloadPianoRoll = (transcription: Transcription) => {
  return VideoService.videoCreate(transcription.id).then((res) => {
    window.location.href = `/video/${res}`;
  });
};
export const handleDownloadUnquantizedMidi = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.setAxiosResponseTypeToBlob();
  const response = TranscriptionService.transcriptionUnquantizedMidi(transcription.id).then(
    (buffer) => {
      saveByteArray(`${transcription.title}.mid`, buffer as any, 'audio/midi');
    },
  );
  backendService.clearAxiosConfig();
  return response;
};

export const handleDownloadGuitarPro = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.setAxiosResponseTypeToBlob();
  const response = TranscriptionService.transcriptionGuitarPro(transcription.id).then((buffer) => {
    saveByteArray(`${transcription.title}.gp5`, buffer as any, 'octet/stream');
  });
  backendService.clearAxiosConfig();
  return response;
};

export const handleDownloadMp3 = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  backendService.setAxiosResponseTypeToBlob();
  const response = TranscriptionService.transcriptionMp3(transcription.id).then((buffer) => {
    saveByteArray(`${transcription.title}.mp3`, buffer as any, 'audio/mp3');
  });
  backendService.clearAxiosConfig();
  return response;
};

export const handleDownloadLilypond = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  const response = TranscriptionService.transcriptionLilypond(transcription.id).then(
    (text: any) => {
      saveText(`${transcription.title}.ly`, text as any);
    },
  );
  return response;
};

export const handleDownloadMusicJson = (transcription: Transcription) => {
  TranscriptionService.transcriptionAccept(transcription.id).then(() => {});
  const response = TranscriptionService.transcriptionMusicJson(transcription.id).then(
    (text: any) => {
      saveText(`${transcription.title}.json`, text as any);
    },
  );
  return response;
};
